import React from "react";

import type { IContextType } from ".";

export const InputPopoverContext = React.createContext<IContextType>(null);
